import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { FieldNodeView } from "@/components/unified/FieldNodeView";

export const FieldNodeExtension = Node.create({
  addAttributes() {
    return {
      fieldDef: {
        default: null,
        parseHTML: (element) => element.dataset.fieldDef,
        renderHTML: (attributes) => ({ "data-field-def": attributes.fieldDef as string | null }),
      },
      sectionId: {
        default: null,
        parseHTML: (element) => element.dataset.sectionId,
        renderHTML: (attributes) => {
          const sectionId = attributes.sectionId as string | null;
          return sectionId ? { "data-section-id": sectionId } : {};
        },
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(FieldNodeView, {
      // Let ProseMirror ignore events that originate from interactive elements
      // inside the NodeView so inputs/selects/buttons receive focus normally.
      stopEvent: ({ event }) => {
        const target = event.target as HTMLElement;
        return target.closest('input, select, textarea, button, label, [role="button"]') !== null;
      },
    });
  },

  atom: true,

  group: "block",

  name: "fieldNode",

  parseHTML() {
    return [{ tag: "div[data-field-def]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", HTMLAttributes];
  },
});
